export enum OtbAccessPolicyType {
    Open = 'Research:Open',
    Embargo = 'Embargo',
    Restricted = 'Restricted',
    Closed = 'Closed',
    MetadataRestricted = 'MetadataRestricted',
    Local = 'Local',
    ClosedPendingApproval = 'ClosedPA',
    Predefined = 'EsploroDateFramePredefinedOperator',
    OpenOperator = 'EsploroOpenForAllOperator',
}
